import ProductsMain from "components/pages/products-page";
import useProductsFunctions from "components/pages/products-page/ts/useProductsFunctions";
import { Helmet } from "react-helmet";
import { Fragment } from "react/jsx-runtime";

export default function ProductsPage() {
  const { first, second, search } = useProductsFunctions();
  const formatParam = (param: string | undefined) =>
    param ? param.replace(/-/g, " ") : "";
  return (
    <Fragment>
      <Helmet>
        <title>
          {first && second
            ? `${formatParam(first).toUpperCase()} ${formatParam(
                second
              ).toUpperCase()}`
            : first
            ? formatParam(first).toUpperCase()
            : search
            ? `Search: ${search.toUpperCase()}`
            : "Car Audio Products & Accessories Online"}
          &nbsp;| Soundlabz
        </title>
        <meta
          name="description"
          content="Shop premium car audio gear including speakers, subwoofers, amplifiers, and LED lights at Soundlabz. Shop now to upgrade your car's audio experience. Available across Houston, TX!"
        ></meta>
      </Helmet>
      <ProductsMain />
    </Fragment>
  );
}
